// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--1x6aQ","bordered":"Card-module--bordered--2x8L1"};